import { Employee } from "@models/employee.model.ts";
import { ChoiceEnum } from "./choiceEnum";

/*
    A role held on an engagement. `is_implied` marks one that comes from an
    Organization-level role rather than a team assignment, so it cannot be
    removed from here.
*/
export class TeamRole extends ChoiceEnum {
  is_implied: boolean;

  constructor() {
    super();
    this.is_implied = false;
  }
}

/*
    One person on an engagement, with every role they hold on it. `id` is the
    employee id — a person can hold several roles, so there is no single row to
    name.
*/
export class TeamMember {
  id: number;
  employee: Employee;
  roles: TeamRole[];

  constructor() {
    this.id = -1;
    this.employee = new Employee();
    this.roles = [];
  }
}
